module.exports = __webpack_public_path__ + "static/media/country_no.5ced1990.webp";